<template>
  <Head title="Política de Privacidad - Realgestion" />
  <div class="container mx-auto px-4 py-8">
    <h1 class="text-3xl font-bold text-darkblue-700 mb-6">Política de Privacidad</h1>
    
    <div class="prose max-w-none">
      <h2 class="text-2xl font-semibold text-darkblue-600 mt-8 mb-4">1. Recopilación de Información</h2>
      <p class="mb-4">
        Recopilamos información personal cuando usted crea una cuenta, realiza una compra o se comunica con nosotros.
        Esta información puede incluir su nombre, dirección, correo electrónico y número de teléfono.
      </p>

      <h2 class="text-2xl font-semibold text-darkblue-600 mt-8 mb-4">2. Uso de la Información</h2>
      <p class="mb-4">
        Utilizamos su información para procesar pedidos, mejorar nuestros servicios y comunicarnos con usted sobre
        su cuenta y productos.
      </p>

      <h2 class="text-2xl font-semibold text-darkblue-600 mt-8 mb-4">3. Protección de Datos</h2>
      <p class="mb-4">
        Implementamos medidas de seguridad para proteger su información personal contra acceso no autorizado y uso indebido.
      </p>
    </div>
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import WebLayout from '@/Layouts/WebLayout.vue'

export default {
  layout: WebLayout,
  components: {
    Head
  }
}
</script> 